import React from "react";
import Header from "./layout/header";
import Footer from "./layout/footer";
import HtipdtBanner from "./hti-product-banner";
import HtipdtInfo from "./hti-product-info";
function AICustomerSupport() {
  return (
    <>
      <Header />
      <main>
        <HtipdtBanner />
        <HtipdtInfo />
      </main>
      <Footer />
    </>
  );
}

export default AICustomerSupport;
